import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import MessageHeader from '@/components/MessageComponent/MessageHeader';

import { BaseResponseType, MessageCenterListBaseResponseResultType, MessageListType, MessageReadBtnType, MessageViewCountType, PaginationParamsType, TableRowSelection } from '@/types/message';
import { deleteMessage, getMessageCount,getMessageList, readMessage } from '@/api/messageCenter';




import './index.less';
import { Button, message, Modal } from 'antd';
import CommonTable from '@/components/MessageComponent/CommonTable';
import usePage from '@/hooks/usePage';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import useRowSelection from '@/hooks/useRowSelection';
import { read } from 'fs';
import messageDispatchCenter from '@/utils/messageDispatchCenter';
const prefix = 'message-view';



const columns: any= [
  { title: '消息内容', dataIndex: 'content' ,width:"60%" },
  { title: '创建时间', dataIndex: 'createTime' },
];

const getDataSource = ()=>{
    return Array.from({ length: 8 }).map((_, i) => {
      const random = Math.random();
      return {
        id:i,
        key: i,
        isRead: random > 0.1,
        content: <div data-index={i} className='message-item-content'>
            <div className={`message-${random>0.1?"read":"unread"}-icon`}></div>
            {`Edward King ${Math.random()*10}`}
          </div>,
        createTime: moment.unix(i).format('YYYY-MM-DD HH:mm:ss'),
      }
    });
}



/**
 * 消息中心
 * @returns 
 */
const MessageView: React.FC = () => {
  const [readCount, setReadCount] = useState<MessageViewCountType>({
    sum: 0,
    unRead: 0,
  });//站内信描述 数据
  const navigate= useNavigate();
  const location=useLocation();
  const pagination=usePage({pageSize:8,currentPage:-1});
  const [open, setOpen] = useState(false);
  const selectType=useRef<any>('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [messageBtnList,setMessageBtnList]=useState<MessageReadBtnType[]>([{
    label:"删除",
    value:"delete",
    isActive:true,
  },{
    label:"标记为已读",
    value:"beRead",
    isActive:true,
  },{
    label:"全部标为已读",
    value:"allRead",
    isActive:true,
  }]);//消息处理按钮

  /**
   * 站内信头部描述
   */
  const messageHeaderDes=useMemo(() =>{
    return `（共${readCount.sum}封，其中${readCount.unRead}封未读）`
  },[readCount]);


  /**
   * 修改站内信总数
   */
  const getReadCount = () => {
    getMessageCount().then((res) => {
      console.log(res);
      if (res?.code === 200) {
        setReadCount(res?.result);
        messageDispatchCenter.emit(0);
      }else{
        window.message.error('获取站内信总数失败');
      }
    }).catch((err: any) => {
      console.log(err);
    }).finally(() => {
      console.log('finally');
    })
  }
  /**
   * 处理 删除、标记为已读、全部标为已读按钮点击事件
   * @param index 
   */
  const handleBtnClick = (index:number) => {
      console.log(index);
      if(index===0){
        //删除
        console.log("删除");
        showModal();
      }
      if(index==1){
        //标记为已读
        console.log("标记为已读");
        marksRead(selectedRowKeys);
      }
      if(index==2){
        //标记为已读
        console.log("标记为已读");
        marksRead(tableData.filter((item:any)=>!item.isRead).map((item:any)=>item.id));
      }
  }
  /**
   * 标记已读
   * @param list 
   */
  const marksRead=(list:any)=>{
    console.log('marks read',selectedRowKeys)
    readMessage({id:list}).then((res:any)=>{
        console.log(res);
        if(res?.code===200){
          console.log('read over');
          changeList({
            pageNumber:pagination.currentPage,
          })
        }
    }).catch((err:any)=>{
        console.log(err);
        window.message.error('标记已读失败');
    })
  }

  const onTableClickHandle= (e:any)=>{
    const id=e.target?.dataset?.index
     if(id){
       console.log(id);
       navigate(`/message/detail?id=${id}&type=${selectType.current}`);
     }
  }
  /**
   * 打开删除弹窗
   */
  const showModal = () => {
    setOpen(true);
  };
  /**
   * 确认删除
   */
  const handleOk = () => {
    setConfirmLoading(true);
    deleteMessage({id:selectedRowKeys}).then((res:any)=>{
      if(res?.code===200){
        console.log('delete over');
        window.message.success('删除成功');
        const page=selectedRowKeys.length!==tableData.length?pagination.currentPage:pagination.currentPage>1?pagination.currentPage-1:1;
        changeList({
          pageNumber:page,
        })
      }
    }).catch((err:any)=>{
      console.log(err);
      window.message.error('删除失败');
    }).finally(()=>{
      setConfirmLoading(false);
      setOpen(false);
    })
  };
  /**
   * 关闭删除弹窗
   */
  const handleCancel = () => {
    console.log('Clicked cancel button');
    setOpen(false);
  };
  
  const {selectedRowKeys,setSelectedRowKeys,rowSelection} = useRowSelection();

  const [tableData,setTableData]=useState<any[]>([]);

  /**
   * 获取表格数据
   */
  const getTableData = (pageData:PaginationParamsType,type:string) => {
    console.log('获取数据',selectType.current);
    const params:any={
      pageSize:pagination.pageSize,
      ...pageData
    }
    if(selectType.current!=''){
      params['isRead']=selectType.current=='unread'?'0':selectType.current=='read'?'1':'';
    }
    getMessageList(params)
    .then((res:MessageListType)=>{
      if(type!=selectType.current){
        return;
      }
      try {
        if(res?.code===200){
          console.log(res);
          setTableData(res?.result?.records.map((item:any)=>{
            return {
              ...item,
              content:<div data-index={item.id} className='message-item-content'>
              <div className={`message-${item.isRead?"read":"unread"}-icon`}></div>
              {item.title}
            </div>,
              key:item.id
            }
          }));
          pagination.setCurrentPage(res?.result?.current);
          pagination.setTotal(res?.result?.total);
        }else{
          window.message.error(res?.message);
        }
      } catch (error) {
        console.error(error);
      }

    }).catch((err:any)=>{
      console.log(err);
    }).finally(()=>{
      pagination.setTableLoading(false);
    })
  }

  /**
   * 初始化数据
   */
  const changeList=(pageData:PaginationParamsType)=>{
    pagination.setTableLoading(true);
    setSelectedRowKeys([]);//清空选中
    getReadCount();
    getTableData(pageData,selectType.current);
  }

  const onPageChange=(current:any)=>{
    console.log('分页改变');
    changeList({
      pageNumber:current,
    })
  }
  /**
   *  分页改变
   */
  // useEffect(() => {
  //   console.log('分页改变',pagination.currentPage);
  //   // if(pagination.currentPage<=0)return;
  //   changeList();
  // },[pagination.currentPage])
  /**
   * 改变 删除、标为已读按钮状态
   */
  useEffect(() => {
    const btns=[...messageBtnList];
    if(selectedRowKeys.length>0){
      btns[0].isActive=false;
      btns[1].isActive=selectedRowKeys.every((item:any)=>tableData?.find((v:any)=>v?.id==item)?.isRead);
    }else{
      btns[0].isActive=true;
      btns[1].isActive=true;
    }
    setMessageBtnList(btns);
  },[selectedRowKeys])
  /**
   * 改变 全部标为已读按钮的状态
   */
  useEffect(() => {
    console.log('tableData改变',tableData,tableData.some((item:any)=>!item.isRead));
    let isRead=true;
    isRead=!tableData.some((item:any)=>!item.isRead);
    setMessageBtnList((data)=>data.map((item,index)=>{
      return {
        ...item,
        isActive:index==2?isRead:item.isActive
      }
    }
    ))
  },[tableData])

  useEffect(() => {
    const searchParams=new URLSearchParams(location.search);
    const type=searchParams.get('type');
    selectType.current=type;
    console.log('路由改变',type);
    changeList({
      pageNumber:1,
    })
  },[location.search])
  return (
    <div className={`${prefix} message-contain-layout`}>
      <MessageHeader title='站内信' des={messageHeaderDes}  />

      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-box`}>
          <div className={`${prefix}-content-box-btns`}>
            {messageBtnList.map((item:MessageReadBtnType,index:number)=>{
              return <Button key={item.value}
              type='primary'
              disabled={item.isActive}
              onClick={()=>{
                handleBtnClick(index);
                }
              } 
              className={`${prefix}-content-box-btns-item`}>
                {item.label}
              </Button>

            })}
          </div>
          <div className={`${prefix}-content-box-table`}>
            <CommonTable
              className={`${prefix}-table`}
              onClick={onTableClickHandle}
              pageChange={onPageChange}
              tableConfig={{
                rowSelection:rowSelection,
                columns:columns,
                dataSource:tableData,
                loading:pagination.tableLoading
              }}
              showSelectText={true}
              paginationConfig={pagination}
            />

          </div>
          
        </div>
      </div>
      <Modal
        title="确定删除此条消息吗？"
        open={open}
        maskClosable={false}
        className={'message-delete-modal modal-warm-icon'}
        centered
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <p></p>
      </Modal>
      
    </div>
  );
};

export default MessageView;


